import { z } from 'zod';
import { FlowApiPageLimitSchema, FlowApiPageOffsetSchema } from '../pagination/pageLimit.js';
/**
 * Query parameters `GET /flow-definitions/{id}/history` accepts.
 *
 * A definition's history is the audit of its own edits, kept separately from the audit trail
 * because an edit is recorded as one entry rather than one per changed field.
 */
export const FlowDefinitionHistoryQuerySchema = z.object({
    userId: z.string().describe('Return only edits made by this user.').optional(),
    userEmail: z.string().describe('Return only edits made by this user.').optional(),
    createdAfter: z.coerce.date().describe('Return only edits made after this time.').optional(),
    createdBefore: z.coerce.date().describe('Return only edits made before this time.').optional(),
    limit: FlowApiPageLimitSchema.describe('How many edits to return.').optional(),
    offset: FlowApiPageOffsetSchema.describe('How many matches to skip, for paging.').optional(),
    orderBy: z.string().describe('Column to order by, such as created.').optional(),
    orderDirection: z.enum(['asc', 'desc']).describe('Direction to order by.').optional(),
    /**
     * Answer with a description of each edit rather than the raw entries. Absent is false, and only
     * `true` or `1` turns it on, so a query string carrying anything else reads as false.
     */
    humanReadable: z
        .string()
        .optional()
        .transform((value) => value === 'true' || value === '1'),
});
//# sourceMappingURL=history.js.map